export function filterWord(value: string, list: string[]): string[] {
  return list.filter(item => item.includes(value));
}
